/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// components
import Notifications from '../../components/Notifications';
import commonUtil from '../../utils/commonUtil';

// Actions
import * as notificationsActions from '../../components/Notifications/actions';
import * as eventDetails from '../../components/EventDetails/actions';
import * as createEventAction from '../../pages/createEvent/actions';
import * as createAccountActions from '../../pages/Accounts/createAccount/actions';
import * as targetterContentActions from '../../pages/BrowseAndNavigate/GiftRegistryhome/actions';
import { updateGiftListHeader } from '../../components/globleObject/actions';
import _ from 'lodash';

@connect(
  (store) => ({
    content: store.targetterContent.data,
    notifications: store.notifications.data,
    countDataNotifications: store.notifications.countData,
    defaultImageNotifications: store.notifications.defaultImage,
    user: store.user.data,
    eventDetails: store.eventDetail,
    lables: store.labels.data,
    globalObject: store.globleObject,
  }),
  {
    ...notificationsActions,
    ...createEventAction,
    ...eventDetails,
    ...createAccountActions,
    ...targetterContentActions,
    updateGiftListHeader,
  },
)
class NotificationWrapper extends Component {
  constructor(props) {
    super(props);

    this.profileId = props.user?.result?.profileId || '';
    this.cancelFunc = this.cancelFunc.bind(this);

    this.isEventManagementRoute = false;
    this.stepBarInfo = {};
    this.eventToken = '';
    this.createEventLogoClick = undefined;
    this.addClass = false;
    this.isClicked = 'false';
    this.lastPath = '';
    this.quitMessage = props.lables?.createEventStep1
      ? commonUtil.getLabel(
          props.lables.createEventStep1,
          'createEventStep1.quitCreatingEvent.message',
        )
      : '';
    this.externalClickHandlerForWapBackButton = null;

    // event management variables
    this.eventManagementMenus = {};
    this.eventManagementMenuHTML = [];
    this.eventManagementRoutes = [];
    this.getEventToolsData = null;
    this.wapTools = null;
  }

  componentDidMount() {
    this.loadNotifications();
  }

  componentDidUpdate(prevProps) {
    const prevProfileId = prevProps.user?.result?.profileId;
    const currProfileId = this.props.user?.result?.profileId;

    if (
      prevProps.eventId !== this.props.eventId ||
      prevProfileId !== currProfileId
    ) {
      this.loadNotifications();
    }
  }

  loadNotifications = () => {
    this.profileId = this.props.user?.result?.profileId || '';
    if (this.profileId && this.props.eventId) {
      const {
        loadNotificationsDetail,
        getNotificationsDefaultImage,
        countNotification,
      } = this.props;
      loadNotificationsDetail(this.props.eventId, this.profileId);
      getNotificationsDefaultImage();
      //countNotification(this.props.eventId, this.profileId, this.isClicked);
    }
  };

  handleOutsideClick = (e) => {
    if (
      !this.notificationContainer.contains(e.target) &&
      this.notificationContainer.style.display === 'block'
    ) {
      this.notificationContainer.style.display = 'none';
    }
  };

  openNotification = (id) => {
    const notificationContainer = document.querySelector(id);
    if (notificationContainer.style.display === 'block') {
      this.isClicked = 'true';
    } else {
      this.isClicked = 'false';
    }

    this.notiModal.handleShow();
    //this.props.countNotification(this.props.eventId, this.profileId, this.isClicked);
  };

  openNotificationBar = () => {
    if (this.notificationContainer?.style?.display === 'none') {
      this.isClicked = 'true';
      this.notificationContainer.style.display = 'block';
      document.addEventListener('click', this.handleOutsideClick, true);
    } else if (this.notificationContainer?.style) {
      this.isClicked = 'false';
      this.notificationContainer.style.display = 'none';
      document.removeEventListener('click', this.handleOutsideClick, true);
    }
    // this.props.countNotification(this.props.eventId, this.profileId, this.isClicked);
  };

  cancelFunc(e) {
    e.preventDefault();
    const { clearEventData } = this.props;
    clearEventData();
  }

  markAllRead = () => {
    if (this.props.notifications?.notifications?.length > 0) {
      this.props.notifications.notifications.forEach((data) => {
        if (data.isRead === 'false' && data.notificationId && this.profileId) {
          this.props.updateNotificationsDetail(
            data.notificationId,
            this.profileId,
          );
        }
      });
      this.props.loadNotificationsDetail(eventId, this.profileId);
      this.props.getNotificationsDefaultImage();
    }
  };

  renderNotification = () => {
    let count = this.props.notifications?.notificationCount || 0;

    return (
      <React.Fragment>
        <span
          id='iconNotifications'
          onClick={this.openNotificationBar}
          onDoubleClick={this.markAllRead}
        >
          {count > 0 ? (
            <span className='icon-notification-red'></span>
          ) : (
            <span className='icon-notification'></span>
          )}
        </span>
        <div
          ref={(el) => (this.notificationContainer = el)}
          className='contentMenuNotifications'
          id='notificacionesMenu'
          style={{ display: 'none' }}
        >
          <Notifications
            notifications={this.props.notifications || null}
            eventId={this.props.eventId}
            profileId={this.profileId}
            openNotificationBar={this.openNotificationBar}
            defaultImageNotifications={
              this.props.defaultImageNotifications || null
            }
          />
        </div>
      </React.Fragment>
    );
  };

  getEventToken = (eventId) => {
    this.props.eventId = eventId;
    const { getEventToken } = this.props;
    getEventToken(this.props.eventId);
  };

  closeTrackModal = () => {
    this.notiModal.handleHide();
  };

  render() {
    return <React.Fragment>{this.renderNotification()}</React.Fragment>;
  }
}

const mapStateToProps = (state) => ({
  data: state.data,
});

const matchDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(NotificationWrapper);
